import { app } from '@isyscore/messenger';
import Axios, { apiVersion, userToken, processFault } from '@isyscore/axios';
import store from '../store';

const userTokenFeature = userToken({
    headerKey: 'token',
    tokenVal() {
        return store.state.sso ? store.state.sso.token : '';
    }
});

const processFaultFeature = processFault({
    appMessenger: app
});

const axios = Axios.create();

const apiVersion2Feature = apiVersion({
    version: '2.0'
});

axios.features.use(apiVersion2Feature).use(userTokenFeature).use(processFaultFeature);

export default axios;
